
export const CLEAR_CONTENT = 'app/content/CLEAR_CONTENT';

export const GET_PERSONALITY_INIT = 'app/content/GET_PERSONALITY_INIT';
export const GET_PERSONALITY_ERROR = 'app/content/GET_PERSONALITY_ERROR';
export const GET_PERSONALITY_SUCCESS = 'app/content/GET_PERSONALITY_SUCCESS';

export const GET_PERSONALITY_V2_INIT = 'app/content/GET_PERSONALITY_V2_INIT';
export const GET_PERSONALITY_V2_ERROR = 'app/content/GET_PERSONALITY_V2_ERROR';
export const GET_PERSONALITY_V2_SUCCESS = 'app/content/GET_PERSONALITY_V2_SUCCESS';

export const GET_PAGES_INIT = 'app/content/GET_PAGES_INIT';
export const GET_PAGES_ERROR = 'app/content/GET_PAGES_ERROR';
export const GET_PAGES_SUCCESS = 'app/content/GET_PAGES_SUCCESS';

export const GET_AGREEMENT_INIT = 'app/content/GET_AGREEMENT_INIT';
export const GET_AGREEMENT_ERROR = 'app/content/GET_AGREEMENT_ERROR';
export const GET_AGREEMENT_SUCCESS = 'app/content/GET_AGREEMENT_SUCCESS';

export const GET_CONSENT_INIT = 'app/content/GET_CONSENT_INIT';
export const GET_CONSENT_ERROR = 'app/content/GET_CONSENT_ERROR';
export const GET_CONSENT_SUCCESS = 'app/content/GET_CONSENT_SUCCESS';

export const GET_DEV_TALK_AGENDA_INIT = 'app/content/GET_DEV_TALK_AGENDA_INIT';
export const GET_DEV_TALK_AGENDA_ERROR = 'app/content/GET_DEV_TALK_AGENDA_ERROR';
export const GET_DEV_TALK_AGENDA_SUCCESS = 'app/content/GET_DEV_TALK_AGENDA_SUCCESS';

export const GET_DEV_TALK_PREPARATION_INIT = 'app/content/GET_DEV_TALK_PREPARATION_INIT';
export const GET_DEV_TALK_PREPARATION_ERROR = 'app/content/GET_DEV_TALK_PREPARATION_ERROR';
export const GET_DEV_TALK_PREPARATION_SUCCESS = 'app/content/GET_DEV_TALK_PREPARATION_SUCCESS';

export const GET_BUSINESS_PROFILE_DESCRIPTION_INIT = 'app/content/GET_BUSINESS_PROFILE_DESCRIPTION_INIT';
export const GET_BUSINESS_PROFILE_DESCRIPTION_ERROR = 'app/content/GET_BUSINESS_PROFILE_DESCRIPTION_ERROR';
export const GET_BUSINESS_PROFILE_DESCRIPTION_SUCCESS = 'app/content/GET_BUSINESS_PROFILE_DESCRIPTION_SUCCESS';

export const GET_BUSINESS_PROFILE_DIMENSIONS_INIT = 'app/content/GET_BUSINESS_PROFILE_DIMENSIONS_INIT';
export const GET_BUSINESS_PROFILE_DIMENSIONS_ERROR = 'app/content/GET_BUSINESS_PROFILE_DIMENSIONS_ERROR';
export const GET_BUSINESS_PROFILE_DIMENSIONS_SUCCESS = 'app/content/GET_BUSINESS_PROFILE_DIMENSIONS_SUCCESS';

export const GET_BUSINESS_PROFILE_FLEXIBILITY_INIT = 'app/content/GET_BUSINESS_PROFILE_FLEXIBILITY_INIT';
export const GET_BUSINESS_PROFILE_FLEXIBILITY_ERROR = 'app/content/GET_BUSINESS_PROFILE_FLEXIBILITY_ERROR';
export const GET_BUSINESS_PROFILE_FLEXIBILITY_SUCCESS = 'app/content/GET_BUSINESS_PROFILE_FLEXIBILITY_SUCCESS';

export const GET_CONTENT_TYPE_INIT = 'app/content/GET_CONTENT_TYPE_INIT';
export const GET_CONTENT_TYPE_ERROR = 'app/content/GET_CONTENT_TYPE_ERROR';
export const GET_CONTENT_TYPE_SUCCESS = 'app/content/GET_CONTENT_TYPE_SUCCESS';

export const GET_PERSONALITY_IRT_FACET_CONTENT_INIT = 'app/content/GET_PERSONALITY_IRT_FACET_CONTENT_INIT';
export const GET_PERSONALITY_IRT_FACET_CONTENT_ERROR = 'app/content/GET_PERSONALITY_IRT_FACET_CONTENT_ERROR';
export const GET_PERSONALITY_IRT_FACET_CONTENT_SUCCESS = 'app/content/GET_PERSONALITY_IRT_FACET_CONTENT_SUCCESS';

export const GET_LOGIC_TEST_RESULT_CONTENT_INIT = 'app/content/GET_LOGIC_TEST_RESULT_CONTENT_INIT';
export const GET_LOGIC_TEST_RESULT_CONTENT_ERROR = 'app/content/GET_LOGIC_TEST_RESULT_CONTENT_ERROR';
export const GET_LOGIC_TEST_RESULT_CONTENT_SUCCESS = 'app/content/GET_LOGIC_TEST_RESULT_CONTENT_SUCCESS';

export const GET_PERSONALITY_RESULT_ERROR = 'app/content/GET_PERSONALITY_RESULT_ERROR';
export const GET_PERSONALITY_RESULT_INIT = 'app/content/GET_PERSONALITY_RESULT_INIT';
export const GET_PERSONALITY_RESULT_SUCCESS = 'app/content/GET_PERSONALITY_RESULT_SUCCESS';

export const GET_LOGIC_REPORT_SCORE_ERROR = 'app/content/GET_LOGIC_REPORT_SCORE_ERROR';
export const GET_LOGIC_REPORT_SCORE_INIT = 'app/content/GET_LOGIC_REPORT_SCORE_INIT';
export const GET_LOGIC_REPORT_SCORE_SUCCESS = 'app/content/GET_LOGIC_REPORT_SCORE_SUCCESS';
